function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "favicon64");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 17,
  height: 20,
  rx: 2
}), React.createElement("rect", {
  id: "path-3",
  x: 0,
  y: 0,
  width: 17,
  height: 20,
  rx: 2
}), React.createElement("rect", {
  id: "path-5",
  x: 0,
  y: 0,
  width: 17,
  height: 20,
  rx: 2
}), React.createElement("rect", {
  id: "path-7",
  x: 0,
  y: 0,
  width: 17,
  height: 20,
  rx: 2
}), React.createElement("rect", {
  id: "path-9",
  x: 0,
  y: 0,
  width: 17,
  height: 20,
  rx: 2
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "favicon64",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  x: 0,
  y: 7,
  width: 64,
  height: 20
}), React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#D8D8D8",
  x: 0,
  y: 37,
  width: 64,
  height: 20
}), React.createElement("g", {
  id: "Value-Block",
  transform: "translate(8.000000, 7.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("rect", {
  stroke: "#979797",
  strokeWidth: 1,
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("g", {
  id: "Red",
  mask: "url(#mask-2)",
  fill: "#E64E42",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 17,
  height: 20
})), React.createElement("rect", {
  id: "Rectangle",
  strokeOpacity: 0.2,
  stroke: "#000000",
  strokeWidth: 1,
  mask: "url(#mask-2)",
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("text", {
  id: "value",
  mask: "url(#mask-2)",
  fontFamily: "SFProDisplay-MediumItalic, SF Pro Display",
  fontSize: 14,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: 0.16882355
})), React.createElement("g", {
  id: "Value-Block",
  transform: "translate(28.000000, 7.000000)"
}, React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3"
})), React.createElement("rect", {
  stroke: "#979797",
  strokeWidth: 1,
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("g", {
  id: "Blue",
  mask: "url(#mask-4)",
  fill: "#3B9AD9",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 17,
  height: 20
})), React.createElement("rect", {
  id: "Rectangle",
  strokeOpacity: 0.2,
  stroke: "#000000",
  strokeWidth: 1,
  mask: "url(#mask-4)",
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("text", {
  id: "value",
  mask: "url(#mask-4)",
  fontFamily: "SFProDisplay-MediumItalic, SF Pro Display",
  fontSize: 14,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: 0.16882355
})), React.createElement("g", {
  id: "Value-Block",
  transform: "translate(38.000000, 7.000000)"
}, React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-5"
})), React.createElement("rect", {
  stroke: "#979797",
  strokeWidth: 1,
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("g", {
  id: "Orange",
  mask: "url(#mask-6)",
  fill: "#FEA829",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 17,
  height: 20
})), React.createElement("rect", {
  id: "Rectangle",
  strokeOpacity: 0.2,
  stroke: "#000000",
  strokeWidth: 1,
  mask: "url(#mask-6)",
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("text", {
  id: "value",
  mask: "url(#mask-6)",
  fontFamily: "SFProDisplay-MediumItalic, SF Pro Display",
  fontSize: 14,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: 0.16882355
})), React.createElement("g", {
  id: "Value-Block",
  transform: "translate(8.000000, 37.000000)"
}, React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-7"
})), React.createElement("rect", {
  stroke: "#979797",
  strokeWidth: 1,
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("g", {
  id: "Red",
  mask: "url(#mask-8)",
  fill: "#E64E42",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 17,
  height: 20
})), React.createElement("rect", {
  id: "Rectangle",
  strokeOpacity: 0.2,
  stroke: "#000000",
  strokeWidth: 1,
  mask: "url(#mask-8)",
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("text", {
  id: "value",
  mask: "url(#mask-8)",
  fontFamily: "SFProDisplay-MediumItalic, SF Pro Display",
  fontSize: 14,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: 0.16882355
})), React.createElement("g", {
  id: "Value-Block",
  transform: "translate(18.000000, 37.000000)"
}, React.createElement("mask", {
  id: "mask-10",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-9"
})), React.createElement("rect", {
  stroke: "#979797",
  strokeWidth: 1,
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("g", {
  id: "Green",
  mask: "url(#mask-10)",
  fill: "#30AD63",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 17,
  height: 20
})), React.createElement("rect", {
  id: "Rectangle",
  strokeOpacity: 0.2,
  stroke: "#000000",
  strokeWidth: 1,
  mask: "url(#mask-10)",
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 19,
  rx: 2
}), React.createElement("text", {
  id: "value",
  mask: "url(#mask-10)",
  fontFamily: "SFProDisplay-MediumItalic, SF Pro Display",
  fontSize: 14,
  fontStyle: "italic",
  fontWeight: 500,
  letterSpacing: 0.16882355
})));

var SvgFavicon64 = function SvgFavicon64(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFavicon64, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/favicon64.6c4960f3.svg";
export { ForwardRef as ReactComponent };